import * as React from 'react';
import { ProductCatalogList } from '../components/Menu';

export const menuConfigItems = {
  profile: {
    root: true,
    title: 'SUBMENU.PROFILE',
    translate: 'SUBMENU.PROFILE',
    page: 'settings/profile',
    activePages: ['settings/profile'],
  },

  products: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['products', 'categories', 'viewproduct'],
    inActivePages: ['products/types'],
    page: 'products/catalog',
    submenu: [
      {
        title: 'PRODUCT.ALL.PRODUCTS',
        translate: 'PRODUCT.ALL.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorProducts: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['products', 'categories', 'viewproduct'],
    submenu: [
      {
        title: 'MENU.COMPANY.PRODUCTS',
        page: 'products/company/list',
        translate: 'MENU.COMPANY.PRODUCTS',
        activePages: ['products/edit', 'products/create'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorCompany: {
    root: true,
    title: 'MENU.VENDOR.COMPANY',
    translate: 'MENU.VENDOR.COMPANY',
    bullet: 'dot',
    activePages: ['companies', 'stores'],
    submenu: [
      {
        translate: 'SUBMENU.COMPANY_SETTINGS',
        title: 'SUBMENU.COMPANY_SETTINGS',
        page: 'companies/list',
        activePages: ['companies/edit', 'companies/new'],
      },
      {
        translate: 'MENU.CATALOG.STORES',
        title: 'MENU.CATALOG.STORES',
        page: 'stores/list',
        activePages: ['stores/edit', 'stores/create'],
      },
    ],
  },

  buyerCompany: {
    root: true,
    title: 'MENU.BUYER.COMPANY',
    translate: 'MENU.BUYER.COMPANY',
    bullet: 'dot',
    page: 'companies/list',
    activePages: ['companies/edit', 'companies/new'],
  },

  orders: {
    root: true,
    title: 'MENU.ORDERS',
    translate: 'MENU.ORDERS',
    bullet: 'dot',
    activePages: ['orders/'],
    page: 'orders/list/full',
  },

  tenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'product_search/list',
    activePages: ['product_search'],
  },

  buyersOrders: {
    root: true,
    title: 'MENU.MY_ORDERS',
    translate: 'MENU.MY_ORDERS',
    bullet: 'dot',
    page: 'orders/list/full',
    activePages: ['orders'],
  },

  users: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/vendors',
    submenu: [
      {
        translate: 'SUBMENU.VENDORS',
        title: 'SUBMENU.VENDORS',
        page: 'users/vendors',
      },
      {
        translate: 'SUBMENU.CUSTOMERS',
        title: 'SUBMENU.CUSTOMERS',
        page: 'users/buyers',
      },
      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: 'companies/list',
      },
    ],
  },

  settings: {
    root: true,
    title: 'MENU.SETTINGS',
    bullet: 'dot',
    translate: 'MENU.SETTINGS',
    activePages: ['products/types'],
    page: 'products/types/list',
    submenu: [
      {
        title: 'MENU.PRODUCTS.TYPES',
        translate: 'MENU.PRODUCTS.TYPES',
        page: 'products/types/list',
        activePages: ['products/types/create'],
      },
    ],
  },

  legal: {
    root: true,
    title: 'SUBMENU.LEGAL',
    translate: 'SUBMENU.LEGAL',
    bullet: 'dot',
    activePages: ['documents'],
    page: 'documents/legacy',
    submenu: [
      {
        title: 'SUBMENU.LEGAL_TERMS',
        translate: 'SUBMENU.LEGAL_TERMS',
        page: 'documents/legacy',
      },
      {
        title: 'SUBMENU.LEGAL_PRIVACY',
        translate: 'SUBMENU.LEGAL_PRIVACY',
        page: 'documents/privacy',
      },
      {
        title: 'SUBMENU.FOR_VENDOR',
        translate: 'SUBMENU.FOR_VENDOR',
        page: 'documents/vendor',
      },
      {
        title: 'SUBMENU.FOR_CUSTOMER',
        translate: 'SUBMENU.FOR_CUSTOMER',
        page: 'documents/customer',
      },
    ],
  },

  catalogForUser: {
    root: true,
    title: 'MENU.CATALOG.PRODUCTS',
    translate: 'MENU.CATALOG.PRODUCTS',
    bullet: 'dot',
    page: 'products/catalog',
    dynamic: () => <ProductCatalogList />,
    activePages: ['products', 'viewproduct'],
  },

  tariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    activePages: ['tariffs'],
    page: 'tariffs/list',
  },

  gpt: {
    root: true,
    title: 'GPT',
    translate: 'GPT',
    bullet: 'dot',
    page: 'settings/gpt',
    activePages: ['settings/gpt'],
    submenu: [
      {
        title: 'MENU.SETTINGS',
        page: 'settings/gpt',
        translate: 'settings/gpt',
      },
      {
        title: 'CHATS.GPT',
        page: 'settings/list-chats',
        translate: 'CHATS.GPT',
      },
    ],
  },
};
